import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatterRequisitionPrecedent } from '@models/requisitions';
import { MatterRequisitionsDispatch } from '@state/matter/requisitions/matter-requisitions.dispatch';
import { SnackbarService } from '@services/ui/snackbar.service';
import { MatterRequisitionsState } from '@state/matter/requisitions/matter-requisitions.state';
import {
	BaseMatterRequisitionModal,
	IBaseMatterRequisitionModalData,
} from '../base-matter-requisition-modal';

export interface IUpdateMatterRequisitionModalData
	extends IBaseMatterRequisitionModalData {
	selectedRequisitionId: string;
}
@Component({
	selector: 'app-update-requisition-modal',
	templateUrl: './update-requisition-modal.component.html',
	standalone: false,
})
export class UpdateRequisitionModalComponent
	extends BaseMatterRequisitionModal<MatterRequisitionPrecedent>
	implements OnInit
{
	statusState$ = this.store.select(MatterRequisitionsState.getCreateStatus);
	selector = MatterRequisitionsState.getRequisitionById;
	successMessage = 'Requisition Successfully Updated on File';
	errorMessage = 'Error Updating Requisition on File';
	selectedRequisition: MatterRequisitionPrecedent;

	constructor(
		@Inject(MAT_DIALOG_DATA) protected data: IUpdateMatterRequisitionModalData,
		protected dialogRef: MatDialogRef<UpdateRequisitionModalComponent>,
		protected snackbarService: SnackbarService,
		private requisitionsDispatch: MatterRequisitionsDispatch,
	) {
		super(data, dialogRef, snackbarService);
	}

	ngOnInit() {
		super.ngOnInit();
	}

	onSubmitAction(requisition: MatterRequisitionPrecedent) {
		const updatedRequisition = {
			...requisition,
			id: this.data.selectedRequisitionId,
		};
		this.requisitionsDispatch.Set(
			this.data.selectedRequisitionId,
			updatedRequisition,
		);
		return updatedRequisition;
	}
}
